import { Request, Response } from "express"

import { getUserByToken } from "../services/token-check.js"
import log from "../log.js"

export const routeTokenCheck = async (req: Request, res: Response) => {
	log(`routeTokenCheck`)

	const token = req.body.token
	// const authorization = req.headers.authorization

	log("token body:" + token)

	if (!token) {
		log("could not find token")
		res.status(401).json({ message: "Authorization token is required" })
		return
	}

	log(`token check value: ${token}`)
	
	try {
		const user = await getUserByToken({ token })

		if (user === null) {
			log(`Could not find user from token`)
			// log(`Could not find user: ${req.body.userName} with password ${req.body.password}`)

			res.status(401).json({ message: "Could not find user from token" })
		} else {
			log(`Found user`)

			res.json(user)
		}
	} catch (error: any) {
		if (error.status === 403) {
			res.status(403).json({ message: "Invalid token" })
		} else {
			throw error
		}
	}
}
